import { Component, OnInit } from '@angular/core';
import { LoggedinService } from '../../services/login/loggedin.service';
import { BaseService } from '../../services/base/base.service';
import { SessionHelper } from '../../shared/services/localstorage';
import { Observable } from 'rxjs/Observable';
import { roleID } from '../../configurations/configuration';
import { UpcomingProgramsService } from '../../services/upcoming-programs/upcoming-programs.service';
import { TasksService } from '../../services/tasks/tasks.service';
import { NotificationsService } from '../../services/notifications/notifications.service';
import * as moment from 'moment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  type = "UpcomingPrograms";
  tasks = [];
  limit: number = 5;
  start: number = 0;
  role: number;
  roleID = roleID;
  filterObj:any={};
  sort:any={
    'startDate':'ASC'
  };
  user: any;
  upcomingPrograms: any;
  notifications = [];
  isViewAll:boolean = false;
  title = "Upcoming Programs [Confirmed]";

  constructor(
    public loggedInService: LoggedinService, private baseService: BaseService, 
    private upcomingProgramsService: UpcomingProgramsService,
    private tasksService: TasksService,
    private notificationsService: NotificationsService) {

   }

  ngOnInit() {
    if(SessionHelper.isLoggedIn()) {
      this.loggedInService.changeStatus(true);
    }
    else {
      this.loggedInService.changeStatus(false);
    }
    this.user = SessionHelper.getSession();
    console.log("userInfo", this.user);
    this.role = this.user.role_id;
    if(this.role===roleID.BRAND_ADMIN_ROLE_ID ){
      this.filterObj = {
        brandId: this.user.brand_id,
        type: this.type,
        startDate:moment(new Date()).format('YYYY-MM-DD')+' 00:00:00'
      } 
    }   
    else if(this.role===roleID.MARKETING_ROLE_ID){
        this.sort = [];
        this.filterObj = {
          brandId: this.user.brand_id,
          type: "MarketingAll",
          // startDate:moment(new Date()).format('YYYY-MM-DD')+' 00:00:00'
          // userType:'marketing'
        } 
        this.title = "Upcoming Programs";
        this.limit = 1000;
    }
    else if(this.role === roleID.SALES_REP_ROLE_ID) {
      this.filterObj = {
        userId: this.user.id,
        brandId: this.user.brand_id,
        type: this.type,
        startDate:moment(new Date()).format('YYYY-MM-DD')+' 00:00:00'
      } 
    }
    this.getUpcomingPrograms(this.filterObj,this.sort);
    this.getTasks();
    this.getEventNotifications();
    
  }

  
 
  getUpcomingPrograms(filterObj,sort ) {
    this.upcomingProgramsService.getUpcomingEvents( sort ,filterObj, this.limit, this.start).subscribe((result: any)=> {
      console.log(result)
      if(result.status) {    
        console.log("getUpcomingEvents", result.data);
        result.data.data.forEach(element => {
          element['date'] = moment(element.date, "YYYY-MM-DD").format("MM-DD-YYYY");
        });   
        this.upcomingPrograms = result.data.data;
      }
    },
    err=> {
      console.log("Error", err);
    });
  }

  getTasks() {

    let filterObj = {
      userId: this.user.id,
      brandId: this.user.brand_id
    } 
    this.tasksService.getTasks(filterObj, this.limit, this.start).subscribe((result:any) => {
      console.log(result);
      if(result.status) {
        result.data.data.forEach(element => {
          element['date'] = moment(element.date, "YYYY-MM-DD").format("MM-DD-YYYY");
        });
        this.tasks = result.data.data;
      }
    },
    err => {
      
    });
  }

  
  getEventNotifications() {
    let filterObj = {
      // userId: this.user.id,
      brandId: this.user.brand_id
    }  
    this.notificationsService.getEventNotifications(filterObj, this.limit, this.start).subscribe((result:any) => {
      console.log(result);
      if(result.status) {
        result.data.data.forEach(element => {
          element['date'] = moment(element.date, "YYYY-MM-DD").format("MM-DD-YYYY");
        });
        this.notifications = result.data.data;
      }
    },
    err => {
      
    });
  }

}
